import { PublicOrganizationHomepage } from "@/components/organization/public-organization-homepage";
import { ensureRouteQueryData } from "@/lib/route-loader";
import { parseOrganizationIdParams } from "@/lib/route-params";
import {
  getOrganizationGetOrganizationPublicQueryOptions,
  useOrganizationGetOrganizationPublic,
} from "@/orval/organization";
import { createFileRoute } from "@tanstack/react-router";

const OrganizationPublicPage = () => {
  const { organizationId } = Route.useParams();

  const { data: organization } = useOrganizationGetOrganizationPublic(organizationId);

  return <PublicOrganizationHomepage organization={organization} organizationId={organizationId} />;
};

export const Route = createFileRoute("/_app/organizations/$organizationId/")({
  params: {
    parse: parseOrganizationIdParams,
  },
  loader: ({ params, ...loaderContext }) =>
    ensureRouteQueryData(loaderContext, getOrganizationGetOrganizationPublicQueryOptions(params.organizationId)),
  component: OrganizationPublicPage,
});
